<template>
  <b-container
    class="date-picker-custom"
    :class="
      this.$props.required && this.$props.state != null
        ? 'img-visible'
        : 'img-invisible'
    "
  >
    <div></div>
    <div :class="focusedClass" class="datepicker-wrapper">
      <b-form-datepicker
        class="datepicker-style"
        :class="this.$props.disabled ? 'isDisabled' : ''"
        :id="datePickerId"
        v-model.lazy.trim="value"
        v-bind="labels[locale] || {}"
        locale="pt-BR"
        placeholder="dd/MM/aaaa"
        size="lg"
        @hidden="onHidden"
        @shown="onShow"
        today-button
        reset-button
        close-button
        :date-format-options="{
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }"
        @context="onContext"
      />
    </div>
    <div>
      <img
        v-if="
          !(
            this.$props.required &&
            !this.$props.state &&
            this.$props.state != null
          )
        "
        class="d-flex align-items-center custom-icon-remove"
        src="@/assets/icons/close-circle.svg"
        @click="removeValue()"
      />
      <img
        v-if="
          this.$props.required &&
          !this.$props.state &&
          this.$props.state != null
        "
        class="d-flex align-items-center custom-icon-remove"
        src="../../assets/images/MDI-alert-circle-outline.svg"
      />
    </div>
    <div
      class="pl-2"
      v-if="
        this.$props.required && this.$props.state && this.$props.state != null
      "
    >
      <div class="d-flex align-items-center h-100">
        <img src="@/assets/images/check.svg" class="img-custom" />
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  props: ["dataValue", "state", "datePickerId", "required", "disabled"],
  async mounted() {
    this.value = this.$props.dataValue;
  },
  watch: {
    value(value) {
      if (value) {
        this.$emit("datePickerChangedValue", value);
      }
    },
  },
  data() {
    return {
      value: null,
      cacheValue: null,
      focusedClass: "",
      locale: "pt-BR",
      labels: {
        "pt-BR": {
          labelPrevDecade: "Década anterior",
          labelPrevYear: "Ano anterior",
          labelPrevMonth: "Mês anterior",
          labelCurrentMonth: "Mês atual",
          labelNextMonth: "Próximo mês",
          labelNextYear: "Próximo ano",
          labelNextDecade: "Próxima década",
          labelToday: "Hoje",
          labelTodayButton: "Hoje",
          labelSelected: "Data selecionada",
          labelNoDateSelected: "Nenhuma data escolhida",
          labelCalendar: "Calendário",
          labelNav: "Navegação no calendário",
          labelHelp: "Navegue pelo calendário usando as teclas de seta",
          labelResetButton: "Reiniciar",
          labelCloseButton: "Fechar",
        },
      },
    };
  },
  methods: {
    onHidden() {
      this.focusedClass = "";
    },
    onShow() {
      this.focusedClass = "date-picker-container-focused";
    },
    onContext(ctx) {
      if (this.updateValue && !this.validateField(ctx.selectedYMD)) {
        this.$emit("datePickerChangedValue", null);
      }

      if (this.cacheValue != null) {
        this.updateValue = this.cacheValue != ctx.selectedYMD;
      }

      this.cacheValue = ctx.selectedYMD;
    },
    validateField(value) {
      return !!value;
    },
    removeValue() {
      if (this.$props.disabled) return;
      this.value = null;
      this.updateValue = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}

.img-custom {
  width: 13px;
  height: 13px;
  margin-left: -45px;
  position: absolute;
}

.img-alert {
  width: 15px;
  height: 15px;
  margin-left: -20px;
}

.date-picker-custom {
  max-width: 100%;
  display: grid;
  border-style: none;
  grid-column: 0;

  margin-right: 0;
}

.img-invisible {
  grid-template-columns: auto 140px 25px;
}

.img-visible {
  grid-template-columns: auto 140px 25px 0px;
}

.custom-icon-remove {
  margin-right: 0.8rem;
  margin-left: 0.2rem;
  margin-top: 0.6rem;
  width: 1.8rem;
  height: 1.8rem;
  cursor: pointer;
  position: relative;
}
</style>
<style lang="scss">
.b-form-datepicker {
  max-height: 3rem;
  label.form-control-lg {
    line-height: 21px;
  }
}
.isDisabled {
  pointer-events: none;
  cursor: pointer;
  text-decoration: none;
  opacity: 0.6;
}

.date-picker-container-focused > div.b-form-btn-label-control {
  color: #495057;
  background-color: #fff;
  border: 2px solid #7adcb6;
  outline: 0;
}

.date-picker-custom div.b-form-datepicker {
  margin-right: -12px !important;
}

.datepicker-wrapper {
  margin-right: 0;
  width: 164px;
}

.b-form-datepicker .datepicker-style {
  margin-right: 0;
  width: 150px;
  margin-left: auto;
}
</style>
